import React from 'react';
import { V1SectionContainer } from './V1SectionContainer';
import { Building2 } from 'lucide-react';

interface Section {
  id: string;
  typeOf: string;
  customTitle?: string;
  sectionOption?: any;
  sectionData?: {
    companiesCount?: number;
  };
}

interface V1CompanyListSectionProps {
  section: Section;
}

/**
 * V1 Company List Section - FROZEN
 *
 * Displays list of companies from registrations.
 * Simple display without search or filtering.
 *
 * DO NOT add V2 features to this component.
 */
export const V1CompanyListSection: React.FC<V1CompanyListSectionProps> = ({ section }) => {
  const companiesCount = section.sectionData?.companiesCount || 0;

  if (companiesCount === 0) {
    return (
      <V1SectionContainer section={section}>
        {section.customTitle && (
          <h2 className="text-2xl font-bold mb-4">{section.customTitle}</h2>
        )}
        <div className="text-center py-8">
          <Building2 className="mx-auto h-12 w-12 text-gray-400 mb-3" />
          <p className="text-gray-500">No companies registered yet.</p>
        </div>
      </V1SectionContainer>
    );
  }

  return (
    <V1SectionContainer section={section}>
      {section.customTitle && (
        <h2 className="text-2xl font-bold mb-6">{section.customTitle}</h2>
      )}

      <div className="bg-gray-50 rounded-lg p-6 text-center">
        <Building2 className="mx-auto h-16 w-16 text-gray-400 mb-4" />
        <p className="text-2xl font-semibold text-gray-900 mb-2">
          {companiesCount}
        </p>
        <p className="text-gray-600">
          {companiesCount === 1 ? 'Company' : 'Companies'} Represented
        </p>
      </div>

      <div className="mt-6 text-sm text-gray-500 text-center">
        <p>Company directory is available to registered attendees.</p>
      </div>
    </V1SectionContainer>
  );
};